module.exports = __webpack_public_path__ + "static/media/brandImg.4ef31b08.png";